<template>
  <path
    fill="currentColor"
    d="M3 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0v15Zm13 0a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0v15ZM13 16a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h6Zm1-2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1Zm1-7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1Zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6Z" />
</template>
